import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { ApplicationFeatures, ApplicationToggles } from 'app/app-features.enum';

import { CurrentUserSelectors } from '.';
import { CurrentUserState } from './current-user.reducer';
import { hasUserManageReportsFeature } from './current-user.selectors';

@Injectable({
    providedIn: 'root',
})
export class CurrentUserFacade {
    hasUserManageReportsFeature$: Observable<boolean> = this.store$.select(hasUserManageReportsFeature);

    hasCurrentUserFeature(feature: ApplicationFeatures | ApplicationToggles) {
        return this.store$.select(CurrentUserSelectors.createHasCurrentUserFeatureSelector(feature));
    }

    constructor(private readonly store$: Store<CurrentUserState>) {}
}
